import { render, staticRenderFns } from "./OptionPricing.vue?vue&type=template&id=566eb4d3&"
import script from "./OptionPricing.vue?vue&type=script&lang=ts&"
export * from "./OptionPricing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports